export const paymentMethodsTemplate = [
  {
    imgSrc: "/images/phone-pay.png",
    altTextKey: "wallet.phonePe.title",
    titleKey: "wallet.phonePe.title",
    descriptionKey: "wallet.phonePe.description",
  },
  {
    imgSrc: "/images/g-pay.png",
    altTextKey: "wallet.googlePay.title",
    titleKey: "wallet.googlePay.title",
    descriptionKey: "wallet.googlePay.description",
  },
];

export const withdrawOptionsTemplate = [
  // {
  //   imgSrc: "/images/phone-pay.png",
  //   altTextKey: "wallet.phonePe.title",
  //   titleKey: "wallet.phonePe.title",
  // },
  // {
  //   imgSrc: "/images/g-pay.png",
  //   altTextKey: "wallet.googlePay.title",
  //   titleKey: "wallet.googlePay.title",
  // },
  {
    imgSrc: "/images/withdraw.png",
    altTextKey: "wallet.withdrawHistory.withdraw",
    titleKey: "wallet.withdrawHistory.withdraw",
  },
  {
    imgSrc: "/images/history.png",
    altTextKey: "wallet.withdrawHistory.history",
    titleKey: "wallet.withdrawHistory.history",
  },
];
